module.exports = __webpack_public_path__ + "img/dl8.67189170.png";